/**
 * Trailing debounce with a hard cap so a continuous SSE hint stream cannot
 * postpone an Inbox refresh forever (C-4b).
 */
export const INBOX_EVENTS_COALESCE_MAX_MS = 1000;

export function planInboxEventCoalesce(input: {
  now: number;
  startedAt: number | null;
  trailingMs: number;
  maxWaitMs: number;
}): { startedAt: number; flushNow: boolean; delayMs: number } {
  const startedAt = input.startedAt ?? input.now;
  const elapsed = input.now - startedAt;
  if (elapsed >= input.maxWaitMs) {
    return { startedAt, flushNow: true, delayMs: 0 };
  }
  const remainingMax = input.maxWaitMs - elapsed;
  return {
    startedAt,
    flushNow: false,
    delayMs: Math.min(input.trailingMs, remainingMax),
  };
}

/** First EventSource open is the initial connect. Later opens are reconnects. */
export function shouldResyncInboxOnEventsOpen(hasOpenedBefore: boolean): boolean {
  return hasOpenedBefore;
}
